import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-testo-termini-e-condizioni',
    templateUrl: './testo-termini-e-condizioni.component.html',
    styleUrls: ['./testo-termini-e-condizioni.component.scss'],
    standalone: false
})
export class TestoTerminiECondizioniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
